<template>
  <div>
    <div class="content">
      <base-block class="mb-0" rounded title="Question">
        <div class="text-center mt-0 mb-4">
          <b><p class="mt-2" v-html="`${question}`"></p></b>
          <div v-if="questionImage">
            <img :src="questionImage" style="width: 25%" />
          </div>
        </div>
      </base-block>
      <br />
      <base-block rounded title="Question Details">
        <div class="bg-white rounded p-3 pr-3 pl-3 mb-3">
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Parent Topic</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ parentTopic }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Topic</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ topic }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Subtopic</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ subtopic }}</b>
            </p>
          </div>
          <div
            class="d-flex pro-det p-2"
            v-if="options.length > 0 && type == 'objective'"
          >
            <p class="mb-0 w-25">Options</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b v-for="(option, index) in options" :key="index"
                >{{ option.option
                }}{{ index == options.length - 1 ? "" : ", " }}</b
              >
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Answer</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-right w-50">
              <b>{{ answer }}</b>
            </p>
          </div>
        </div>
      </base-block>

      <div v-if="solutions.length > 0">
        <base-block class="mb-0" rounded title="Solutions">
          <div
            v-for="(solution, index) in solutions"
            :key="index"
            class="text-center"
          >
            <div v-if="solution.type == 'video'">
              <iframe
                width="560"
                height="315"
                :src="youtube_url + solution.youtube_id"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
              <p class="mt-4">{{ solution.description }}</p>
            </div>
            <div v-if="solution.type == 'description'">
              <img
                :src="solution.image"
                alt=""
                style="width: 560px; height: 315px"
                v-if="solution.image != null"
              />

              <p class="mt-4" v-html="`${ solution.description }`"></p>
            </div>
            <hr />
          </div>
        </base-block>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      youtube_url: "https://www.youtube.com/embed/",
      type: "",
      solutions: [],
      answer: "",
      question: "",
      questionImage: "",
      options: [],
      parentTopic: "",
      topic: "",
      subtopic: "",
    };
  },
  watch: {
    solutions: function () {
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },

    question: function () {
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },
  },
  mounted() {
    this.getQuestion();
  },
  methods: {
    async getQuestion() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/question/edit/${this.$route.params.id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.question = response.data.question.question;
            this.questionImage = response.data.question.image;
            this.options = response.data.question.options;
            this.parentTopic = response.data.question.belongtopics[0].name;
            this.topic = response.data.question.belongtopics[1].name;
            this.subtopic = response.data.question.belongtopics[2].name;
            this.answer = response.data.question.answer;
            this.solutions = response.data.question.solutions;
            this.type = response.data.question.question_type;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>